<template>
  <div>
    <p class="warning-dark mb-5">{{ $t('login.login_sign_in.error_info_modal.warning') }}</p>
    <div class="explanation-wrapper d-flex align-items-center justify-content-between" aria-hidden="true">
      <div class="position-relative">
        <span class="additional-pin font-weight-bold">1x</span>
        <p class="title nano mb-3">{{ $t('login.login_sign_in.error_info_modal.activation_code') }}</p>
        <img
          src="/brandings/default/login/sdui-activation-code.png"
          width="88px"
          class="primary-svg-filter"
          alt=""
          loading="lazy"
        />
      </div>
      <div class="not-equal">
        <p class="mb-0 font-weight-bold">=</p>
      </div>
      <div>
        <p class="title nano mb-3">{{ $t('login.login_sign_in.error_info_modal.password') }}</p>
        <SInput
          :label-text="$t('login.login_sign_in.error_info_modal.email.placeholder')"
          hide-label
          type="text"
          size="md"
          disabled
          class="mb-2 mini-input"
          :placeholder="$t('login.login_sign_in.error_info_modal.email.placeholder')"
        />
        <SInput label-text="password"
                hide-label
                type="text"
                size="md"
                disabled
                class="mb-3 mini-input"
                placeholder="*****"
        />
      </div>
    </div>

    <p class="mt-4 mb-0" v-html="$sanitize($t('login.login_sign_in.error_info_modal.explanation'))" />
    <b-button variant="link"
              class="reset-button font-weight-bolder"
              @click="$emit('openExplanatoryModal')"
    >
      {{ $t('login.login_sign_in.error_info_modal.help_modal_label') }}
    </b-button>

    <SModalPortalTo>
      <b-button size="lg"
                block
                variant="primary"
                @click="$emit('close')"
      >
        {{ $t('login.login_sign_in.error_info_modal.close') }}
      </b-button>
      <b-button variant="link"
                size="lg"
                block
                class="text-center font-weight-bolder"
                @click="$router.push({ name: 'login-forgot-data' })"
      >
        {{ $t('login.login_sign_in.forgot_access_data') }}
      </b-button>
    </SModalPortalTo>
  </div>
</template>

<script>
import brandingMixin from 'src/mixins/branding/brandingMixin.js'
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'

export default {
  name: 'LoginErrorInfo',
  components: { SModalPortalTo },
  mixins: [brandingMixin],
  props: {
    section: {
      type: String,
      default: '',
    },
  },

  computed: {},

  emits: ['close', 'openExplanatoryModal'],
}
</script>

<style scoped lang="scss">
.explanation-wrapper {
  border: 1px solid $color-gray-100;
  padding: 12px;
  max-width: 350px;
  margin: 0 auto;
  border-radius: 5px;

  :deep(.s-input__input) {
    width: 100px;
    height: calc(1.1em + 0.75rem + 2px);
    border-radius: 7px;
  }

  .not-equal {
    position: relative;
    font-size: pxtorem(35);

    &::after {
      content: '';
      position: absolute;
      width: 50px;
      background-color: $color-primary;
      opacity: 0.7;
      height: 4px;
      top: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      left: 50%;
    }
  }
}

.additional-pin {
  font-size: pxtorem(23);
  position: absolute;
  right: 10px;
  top: 12px;
}

.mini-input :deep(.s-input__input:disabled) {
  color: $color-primary;
  background-color: $color-secondary;
}
</style>
